module.exports = __webpack_public_path__ + "static/Surgery-93fc27d6b052595010975dfd834b5fce.png";